import { OverheatingAlarm } from './overheating.alarm';
import { WheelAlertAlarm } from './wheel-alert.alarm';
import { TrainDependencyAlarm } from './train-dependency.alarm';

// export type TechnicalAlarm = WheelAlertAlarm | OverheatingAlarm;
// export type ConflictAlarm = TrainDependencyAlarm;
export const ConflictAlarmTypes = ['vrTrainConflict'];
export const TechnicalAlarmTypes = ['vrWheelAlert', 'vrOverheating', 'vrVoltageAlert'];
export interface TechnicalAlarmPayload {
    tripNumber: string;
    tripDate: string;
    location?: string;
    message: string;
}
